import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import { Button, Spacer, TextButton } from 'design-system';
import BlurAmountView from 'design-system/BlurAmountView';
import { useAppSelector } from 'store/hooks';
import Links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import { isWeb } from '../../../constants';
import AboutInfoRow from './AboutInfoRow';
const handleLearnMore = () => {
    Links.openKnownLink('fxFees');
};
const FxFeeBreakdownModalContent = ({ onPress, fxInfo }) => {
    const navigation = useMainStackNavigation();
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const handleUpgrade = useCallback(() => {
        Modal.hide(() => {
            if (isWeb) {
                UpgradeWebModal.show(undefined);
                return;
            }
            navigation.navigateDeprecated('EmmaProModal', { benefitId: 'fxFees' });
        }, { top: true });
    }, []);
    return (<>
      <BlurAmountView enabled={scrambled}>
        <AboutInfoRow noPaddingHorizontal title={fxInfo.fxRateTitle} info={fxInfo.fxRateInfo}/>
        <AboutInfoRow noPaddingHorizontal title={fxInfo.baseRateTitle} info={fxInfo.baseRateInfo}/>
        <AboutInfoRow noPaddingHorizontal title={fxInfo.fxFeeTitle} info={fxInfo.fxFee}/>
      </BlurAmountView>
      <Spacer h={16}/>
      <View style={styles.textBtnContainer}>
        <TextButton onPress={handleLearnMore}>
          <Text TextThin-16 Secondary>
            What is this fee?{' '}
            <Text Text-16 Primary>
              Learn more
            </Text>
            .
          </Text>
        </TextButton>
      </View>
      <Spacer h={16}/>
      {fxInfo.showLowerFxFees ? (<>
          <Button brandReversed title="Want a lower FX fee?" onPress={handleUpgrade}/>
          <Spacer h={8}/>
        </>) : null}
      <Button brand title="Okay, thanks" onPress={onPress}/>
    </>);
};
export const FxFeeBreakdownModal = {
    show: (fxInfo) => {
        Modal.show(<FxFeeBreakdownModalContent fxInfo={fxInfo} onPress={() => {
                Modal.hide(undefined, { top: true });
            }}/>, {
            title: 'FX fee breakdown',
            top: true,
        });
    },
    hide: () => {
        Modal.hide(undefined, { top: true });
    },
};
const styles = StyleSheet.create({
    textBtnContainer: {
        alignItems: 'center',
    },
});
